import gql from 'graphql-tag';

export default gql(`
  fragment ChannelContractFragment on ChannelContract {
    _id
    _created
    _updated
    name
    lastContact
    settings
    _createdBy {
      _id
    }
    _updatedBy {
      _id
    }
    channel {
      _id
      name
      slug
    }
    contactUser {
      _id
    }
    salesUser {
      _id
    }
    managerUser {
      _id
    }
    supportUser {
      _id
    }
    lineItems {
      _id
      _created
      _updated
      name
      _createdBy {
        _id
      }
      _updatedBy {
        _id
      }
      channelContract {
        _id 
      }
      unitType
      units
      pricePerUnit
      currency
      subscriptionStartDate
      estimatedSubscriptionStartDate
      termLengthMonths
      settings
    }
  }
`);
